export default val => {
  if (val === undefined) {
    return true;
  }

  if (
    typeof val === 'function' ||
    typeof val === 'number' ||
    typeof val === 'boolean' ||
    Object.prototype.toString.call(val) === '[object Date]'
  ) {
    return false;
  }

  // null or 0 length array
  if (val == null || val.length === 0) {
    return true;
  }

  // empty object
  if (typeof val === 'object') {
    return Object.keys(val).length === 0;
  }

  return false;
};
